import { HStack, VStack } from '@chakra-ui/react';

import {
  getBankAccountDisplayName,
  parseBankAccountIllustrationName,
} from 'common/bankAccount/utils';
import { formatAmount } from 'common/formatAmount';
import Text from 'components/_core/Text';
import BankAccountIcon from 'components/BankAccountIcon';

import { PartialBankAccount } from '../../types';

const BankAccountDetails = ({
  bankAccount,
}: {
  bankAccount: PartialBankAccount;
}) => (
  <HStack flex={1} spacing="space-8">
    <BankAccountIcon
      illustrationName={parseBankAccountIllustrationName(
        bankAccount.illustrationName,
      )}
      size="md"
    />
    <VStack alignItems="start" spacing={0}>
      <Text fontWeight="weight-500" noOfLines={1} variant="primary">
        {getBankAccountDisplayName(bankAccount)}
      </Text>
      <Text size="sm" variant="light">
        {formatAmount({
          currency: 'EUR',
          forcePlusSign: false,
          value: bankAccount.nextBalance / 100,
        })}
      </Text>
    </VStack>
  </HStack>
);

export default BankAccountDetails;
